import { secureHttp } from '../secureHttp';
import type { SessionLite } from '../../../types/session-lite';

export interface SessionsByDayResponse {
  [dateISO: string]: SessionLite[];
}

export interface SessionsByDayQuery {
  from?: string;
  to?: string;
  status?: string;
}

/**
 * Obtiene las sesiones agrupadas por día
 * Este endpoint es específico para el calendario de sesiones
 */
export async function getSessionsByDay(params?: SessionsByDayQuery): Promise<SessionsByDayResponse> {
  // Añadir un parámetro de timestamp para evitar respuestas 304 Not Modified
  const timestamp = Date.now();
  
  try {
    const response = await secureHttp.get<SessionsByDayResponse>(
      '/v1/psi-platform/psychologist/sessions/by-day', 
      { 
        ...params, 
        _t: timestamp
      }
    );
    
    return response;
  } catch (error) {
    console.error('Error obteniendo sesiones por día:', error);
    return {}; // Devolver objeto vacío en caso de error
  }
}
